const items = [
  "NO PAID RANKINGS",
  "NO PROMOTED OPPORTUNITIES",
  "NO “TRY THIS INSTEAD”",
  "JUST THE SCOOP",
  "DREAM • GOAL • CATCH • RECEIPTS",
  "BEFORE YOU BUY THE DREAM, CHECK THE LIZARD",
];

export const Marquee = () => {
  const row = [...items, ...items];
  return (
    <div
      className="overflow-hidden border-y border-[#E5DFD7] bg-[#EBF7EE] py-3 select-none"
      data-testid="editorial-marquee"
      aria-hidden="true"
    >
      <div className="marquee-track flex w-max items-center gap-8 pr-8">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-8 font-mono text-[11px] font-semibold uppercase tracking-[0.18em] text-[#14532D]">
            {item}
            <span className="w-1.5 h-1.5 rounded-full bg-[#22C55E]" />
          </span>
        ))}
      </div>
    </div>
  );
};
